// `/businesses/*` sub-tree layout — passes the outlet through unmodified.
// The list and editor share a single padding wrapper handled by the
// authed AppShell main column; this layout keeps the route tree explicit.

import { Outlet, createRoute } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'businesses',
  component: BusinessesLayout,
});

function BusinessesLayout() {
  return <Outlet />;
}
